import { useQuery } from "@tanstack/react-query";
import { getManualSoldOutEligibility } from "services/scratcherService";
import type { ManualSoldOutEligibilityResult } from "services/scratcherService";

interface ManualSoldOutEligibilityPack {
  game_id: string;
  pack_id: string;
}

export function useAuditDashboardManualSoldOutEligibility(
  storeId: string | null | undefined,
  packs: ManualSoldOutEligibilityPack[],
  enabled = true
) {
  return useQuery<ManualSoldOutEligibilityResult[], Error>({
    queryKey: ["audit-dashboard-manual-sold-out-eligibility", storeId, packs],
    queryFn: async () => {
      if (!storeId) return [];

      const response = await getManualSoldOutEligibility(storeId, packs);
      if (!response.success) {
        throw new Error(response.error || "Failed to load pack sold-out eligibility");
      }

      return response.data?.results ?? [];
    },
    enabled: Boolean(enabled && storeId && packs.length > 0),
    retry: false,
  });
}
